<div class="login-background">
  <div
    *ngIf="environmentConfig.TITLE === 'MYDHL BREAKBULK DEV'"
    class="d-flex col-12 align-items-center justify-content-center">
    <div class="m-2 p-1 rounded">
      <mat-checkbox [(ngModel)]="isChecked" class="text-wrap" id="checkbox">
        Old Login
      </mat-checkbox>
    </div>
  </div>

  <div *ngIf="isChecked" class="p-2 d-flex justify-content-center align-items-center">
    <div class="col-sm-3 mat-card p-4 rounded mt-4">
      <h3 class="login-heading m-4 mt-1 text-center">MyDHL Breakbulk Login</h3>
      <form [formGroup]="loginForm" (ngSubmit)="loginUser()" method="post" autocomplete="off">
        <div class="row">
          <div class="col-12 pb-3">
            <input
              id="username"
              type="text"
              placeholder="User ID"
              formControlName="username"
              class="form-control"
              required
              email />
          </div>

          <div class="col-12">
            <input
              id="password"
              type="password"
              placeholder="Password"
              class="form-control"
              formControlName="password"
              required />
          </div>

          <div class="col-12 pb-2 pt-3 mb-1">
            <button
              type="submit"
              id="btnLogin"
              class="btn login-page-button"
              [disabled]="loginForm.invalid">
              LOGIN
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="!isChecked" class="p-2 d-flex justify-content-center">
    <div class="col-4 col-xl-4 col-lg-4 col-md-4 mt-5 text-center">
      <div class="p-2 mat-card custom-card">
        <h3 class="login-heading m-4">LOGIN TO MYDHL BREAKBULK</h3>
        <div>
          <div class="row">
            <div class="col-12 pl-5 pe-5 pb-2 pt-3">
              <a [href]="passLoginUrl" style="color: inherit; text-decoration: none">
                <button class="btn login-page-button pb-2">LOGIN</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="col-3"></div> -->
</div>
